import VideoModal from "../../../components/base/video-modal";

export default class PageModule {
    constructor() {
        this.initContentVideo();
    }

    initContentVideo() {
        if (!document.querySelector('[data-modal-trigger="content-video"]')) {
            return;
        }

        new VideoModal({ id: 'content-video' });
    }
}